import axios from 'axios'
import store from '@/store/index'

const headers = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
    },
}
const apiUrl = process.env.VUE_APP_API_URL
const tempCountry = process.env.VUE_APP_COUNTRY_TEMP

/**
 * OCR V2 — `customers/v2/ocr`. `documentType` comes from DocumentUploadConfiguration `OCRValue.v2`.
 * @param {{ frontFileName?: string, backFileName?: string }} fileNames
 * @param {string} documentType
 * @param {string} dataSegmentId
 */
export async function ocrV2(fileNames, documentType, dataSegmentId) {
    try {
        const authHeaders = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
            },
        }
        const frontFileName = typeof fileNames === 'object' ? fileNames.frontFileName : null
        const backFileName = typeof fileNames === 'object' ? fileNames.backFileName : null

        if (!frontFileName && !backFileName) {
            return { result: false, isV2: true, error: 'At least one document (front or back) is required.' }
        }

        const payload = {
            documentType: (documentType || 'passport').toLowerCase().trim(),
            dataSegmentId: dataSegmentId || '',
        }
        if (frontFileName) payload.frontFileName = frontFileName
        if (backFileName) payload.backFileName = backFileName

        const { data } = await axios.post(apiUrl + 'customers/v2/ocr', payload, {
            headers: { ...authHeaders.headers, 'Content-Type': 'application/json' },
        })

        if (data && data.success && data.data) {
            return { result: true, isV2: true, ...data.data }
        }

        return { result: false, isV2: true }
    } catch (e) {
        if (e.response && e.response.status === 422) {
            return {
                result: false,
                isV2: true,
                error:
                    e.response.data && e.response.data.error
                        ? e.response.data.error
                        : 'System Processing failed, please try again later',
            }
        }
        console.error('OCR v2 error:', e)
        if (e.response && e.response.status === 401) {
            await store.dispatch('authLogout')
        }
        throw e
    }
}

let cardTypesForGeneric = [
                           'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                           'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                           'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                           'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                           'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                           'NON PT 0 FRONT'
                         ]
let cardTypesForFatherName = ['PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK','PKR NICOP 0 FRONT','PKR NICOP 1 FRONT']
let cardTypesForIdentityInfo = [
                                 'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                                 'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK','PKR CNIC 1 FRONT',
                                 'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK','PKR NICOP 1 FRONT','PKR NICOP 0 FRONT','PKR NICOP 0 BACK',
                                 'QAT RP 0 FRONT', 'QAT RP 1 FRONT',
                                 'ARE ID 0 FRONT', 'ARE ID 0 BACK', 
                                 'ARE ID 1 FRONT', 'ARE ID 1 BACK'
                                ]

let cardTypesForPassport = [
                             'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                             'NON PT 0 FRONT',
                            ]
let cardTypesForNationality = [
                               'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                               'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                               'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                               'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                               'NON PT 0 FRONT',
                               'QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK',
                               'ARE ID 0 FRONT', 'ARE ID 0 BACK', 
                               'ARE ID 1 FRONT', 'ARE ID 1 BACK'
                            ]
let cardTypesForGender = [ 
                           'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK','PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                           'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                           'NON PT 0 FRONT',
                         ]
let cardTypesForName = [
                        'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                        'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                        'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                        'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                        'NON PT 0 FRONT',
                        'GBR BRP 0 FRONT', 'GBR BRP 0 BACK',
                        'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                       ]
let cardTypesForDob = [
                       'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                       'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                       'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                       'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                       'NON PT 0 FRONT',
                       'GBR BRP 0 FRONT', 'GBR BRP 0 BACK',
                       'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                      ]
let cardTypesForOcrPic = [
                        'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                        'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                        'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                        'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                        'NON PT 0 FRONT',
                        'GBR BRP 0 FRONT', 'GBR BRP 0 BACK',
                        'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                       ]
let cardTypeList = null

/**
 * Parse DocumentUploadConfiguration OCRValue.v1 (e.g. "['NON PT 0 FRONT']").
 * @param {string} v1Str
 * @returns {string[]}
 */
export function parseOcrValueV1FromConfig(v1Str) {
    if (!v1Str || typeof v1Str !== 'string') return []
    var out = []
    var re = /'([^']+)'/g
    var m
    while ((m = re.exec(v1Str)) !== null) {
        out.push(m[1].trim())
    }
    return out
}

/**
 * Keep only entries for the request side (e.g. both QAT RP fronts when side is FRONT).
 * @param {string[]} types
 * @param {string} side - 'FRONT' | 'BACK'
 * @returns {string[]}
 */
export function filterOcrV1TypesForCardSide(types, side) {
    if (!types || types.length === 0) return []
    var suffix = side === 'BACK' ? 'BACK' : 'FRONT'
    return types.filter(function(t) {
        return t.indexOf(suffix) !== -1
    })
}

/**
 * Serialize types back to OCRValue.v1-shaped string for the OCR API.
 * @param {string[]} types
 * @returns {string}
 */
function formatOcrV1TypesAsConfigString(types) {
    if (!types || types.length === 0) return ''
    return "['" + types.join("', '") + "']"
}

/**
 * Legacy OCR v1 (customers/ocr).
 * When `ocrValueV1FromConfig` is set, `cardTypeList` is limited to types for the request `side` (e.g. Qatar RP:
 * both FRONT entries for front upload, both BACK for back). One type for that side → send `cardType` only;
 * several → send the filtered list with empty `cardType`. Pass `overrideCardType` for paired back (e.g.
 * QAT RP 0 FRONT detected → QAT RP 0 BACK).
 * @param {string|null} ocrValueV1FromConfig - raw OCRValue.v1 from upload config, or null to use getCardTypeList(store)
 */

/**
 * True when legacy OCR HTTP payload reports success ({@code statusCode === 200}).
 * If status is not 200, callers should clear the upload (same as V2 failure).
 * Accepts {@code status_code} as well as {@code statusCode}.
 * @param {*} result - return value of {@link ocr} ({@code data.data} from the API)
 * @returns {boolean}
 */
export function isOcrV1ResponseSuccess(result) {
    if (!result || typeof result !== 'object') return false
    var code =
        result.statusCode !== undefined && result.statusCode !== null
            ? result.statusCode
            : result.status_code
    return Number(code) === 200
}

export async function ocr(value,side, overrideCardType = null, isAuthenticated = false, cardTypeListKey = null, ocrValueV1FromConfig = null) {
    try {
        let cardType = store.getters.getField('identityInfo.cardType');
        console.log('ocr',value,side, overrideCardType, isAuthenticated, cardTypeListKey, ocrValueV1FromConfig)
        if(ocrValueV1FromConfig){
            var allConfigTypes = parseOcrValueV1FromConfig(ocrValueV1FromConfig)
            var sideOnlyTypes = filterOcrV1TypesForCardSide(allConfigTypes, side)
            cardTypeList =
                sideOnlyTypes.length > 0
                    ? formatOcrV1TypesAsConfigString(sideOnlyTypes)
                    : ocrValueV1FromConfig

            // var overrideWasPassed =
            //         overrideCardType !== null &&
            //         overrideCardType !== undefined &&
            //         overrideCardType !== ''
            // if (!overrideWasPassed) {
            //         // Single option for this side (e.g. passport): send cardType only. Multiple (e.g. Qatar RP fronts): send list, no cardType.
            //         if (sideOnlyTypes.length === 1) {
            //             overrideCardType = sideOnlyTypes[0]
            //         } else {
            //             overrideCardType = ''
            //         }
            //     }
        }

        if(overrideCardType){
            overrideCardType = cardTypeList.includes(overrideCardType) ? overrideCardType : ""
        }
        else{
            overrideCardType = ""
        }
        let resolvedCardType = overrideCardType || ""

    

        // cardTypeList =  ( cardTypeListKey && getCardTypeList(cardTypeListKey ) )|| getCardTypeList(cardType)
        // overrideCardType = cardTypeList.includes(overrideCardType) ?  overrideCardType : ""
        let payload = {
            'cardSide':side,
            'cardType': resolvedCardType,
            'cardTypeList': resolvedCardType ? "" : cardTypeList,
            // 'country': process.env.VUE_APP_COUNTRY_TEMP,
            'filePath':value,
            isAuthenticated
        }

        // For unprotected routes (deeplink, document-upload), send dataSegmentId in payload
        // This is needed because req.user is not available in unprotected routes
        // isAuthenticated=true means "skip authentication" for public routes
        if (isAuthenticated && store.getters.dataSegmentId) {
            payload.dataSegmentId = store.getters.dataSegmentId;
        }


        let { data } = await axios.post(apiUrl + 'backend/customers/ocr', payload, headers)

        if(data && data.data){   
            // setDocumentSummary(data.data)
            return data.data
        }else{
            return false
        }
    }catch (e) {
        console.log('OCR error 1',e)
        if (e.response && e.response.status === 401 && !isAuthenticated) {
            await store.dispatch('authLogout')
        }
        return false
    }
}

/**
 * Helper function to check if a value is empty
 */
function isEmptyValue(value) {
    return value === null || value === undefined || value === '' || 
           (typeof value === 'object' && Object.keys(value).length === 0);
}

/**
 * Helper function to safely update field only if new value is non-empty
 * Preserves existing values when new value is empty
 */
function safeUpdateField(key, newValue) {
    // If new value is empty, don't update (preserve existing)
    if (isEmptyValue(newValue)) {
        return;
    }
    
    // Get existing value
    const existingValue = store.getters.getField(key);
    
    // Only update if new value is non-empty
    if (!isEmptyValue(newValue)) {
        store.commit('updateField', {
            key: key,
            value: newValue,
        });
    }
}

export async function setDocumentSummary(data = null, isReset = false){

    console.log('setDocumentSummary',data,isReset)
    // If reset, clear all fields
    if (isReset) {
        store.commit('updateField', { key: 'basicInfo.firstName', value: '' });
        store.commit('updateField', { key: 'basicInfo.dateOfBirth', value: '' });
        store.commit('updateField', { key: 'basicInfo.gender', value: '' });
        store.commit('updateField', { key: 'basicInfo.genderId', value: null });
        store.commit('updateField', { key: 'basicInfo.nationality', value: '' });
        store.commit('updateField', { key: 'basicInfo.nationalityId', value: null });
        store.commit('updateField', { key: 'documentInfo.ocrPicture.fileName', value: '' });
        return;
    }

    if (!data || !data.ocrData) return;

    let nationalityId = null;
    let nationalityTitle ='';
    let genderId = null;
    let genderTitle = '';
    // Extract values from OCR data (use optional chaining for identity in case BACK returns null)
    let name = data.ocrData.name || '';
    let dob = data.ocrData.dob || '';
    let gender = data.ocrData.gender || null;
    let fatherName = data.ocrData.fatherName || '';
    
    if(gender){
        genderId = gender.id || null;
        genderTitle = gender.title || '';

    }
    let nationality = data.ocrData.nationality || null;
    if(nationality){
        nationalityId = nationality.id || null;
        nationalityTitle = nationality.title || '';
    }
   
    let picture = data.ocrData.picture || '';
    let identity = data.ocrData.identity || null;
    let identityType = identity && identity.type ? identity.type : null;
    let identityNumber = identity && identity.number ? identity.number : '';
    let identityExpiry = identity && identity.expiry ? identity.expiry : '';

    // Only update when value is non-empty (safeUpdateField) - preserves existing data when FRONT/BACK
    // returns null/empty for some fields (e.g. back typically has less data; re-uploading back only)
    safeUpdateField('basicInfo.firstName', name);
    safeUpdateField('basicInfo.dateOfBirth', dob);
    safeUpdateField('basicInfo.gender', genderTitle);
    safeUpdateField('basicInfo.genderId', genderId);
    safeUpdateField('basicInfo.nationality', nationalityTitle);
    safeUpdateField('basicInfo.nationalityId', nationalityId);
    safeUpdateField('basicInfo.fatherName', fatherName);
    safeUpdateField('documentInfo.ocrPicture.fileName', picture);

    // Handle identity fields based on type
    if(identityType == 'passport'){
        if (data.documentSummary) {
            data.documentSummary.heading = "Passport Document Summary";
            store.commit('updateField', {
                key: 'identityInfo.passport.documentSummary',
                value: data.documentSummary
            });
        }
        safeUpdateField('identityInfo.passport.number', identityNumber);
        safeUpdateField('identityInfo.passport.expiryDate', identityExpiry);
    }
    else if(identityType){
        if (data.documentSummary) {
            data.documentSummary.heading = "National Id Document Summary";
            store.commit('updateField', {
                key: 'identityInfo.documentSummary',
                value: data.documentSummary
            });
        }
        safeUpdateField('identityInfo.number', identityNumber);
        safeUpdateField('identityInfo.expiryDate', identityExpiry);
    }
}


async function ocrFieldReset(cardType = null,data = null) {
//    let TypesForIdentityInfo = ['license','URDU','SMART','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
//    let TypesForPassport = ['passport', 'passportMRZ',]
//    let TypesForNationality = ['SMART','passport','passportMRZ','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
//    let TypesForGender = ['SMART','passport','passportMRZ']
//    let TypesForGeneric = ['license','SMART','URDU','passport','passportMRZ']
//    let selectedCardType = store.getters.getField("identityInfo.cardType");

      
   if(cardType){
       cardTypeList = [cardType]
    }
    else if(data && data.cardTypeList){
       cardTypeList = data.cardTypeList
    }
   if(cardTypesForGeneric.some(element=> cardTypeList.includes(element))){
            store.commit('updateField', {
                key: 'basicInfo.firstName',
                value: null,
            })
    
            store.commit('updateField', {
                key: 'basicInfo.dateOfBirth',
                value:null,
            })
            store.commit('updateField', {
                key: 'documentInfo.ocrPicture.fileName',
                value: null,
            })
    } 
    if(cardTypesForGender.some(element=> cardTypeList.includes(element))){
        store.commit('updateField', {
            key: 'basicInfo.gender',
            value: null,
        })
        store.commit('updateField', {
            key: 'basicInfo.genderId',
            value: null,
        })
    }
    if(cardTypesForNationality.some(element=> cardTypeList.includes(element)) && await isUpdateField('basicInfo.nationality')){
        store.commit('updateField', {
            key: 'basicInfo.nationalityId',
            value: null,
        })
        store.commit('updateField', {
            key: 'basicInfo.nationality',
            value: null,
        })
    }
    if( cardTypesForIdentityInfo.some(element=> cardTypeList.includes(element)) ){
        store.commit('updateField', {
            key: 'identityInfo.number',
            value: null,
        })
        store.commit('updateField', {
            key: 'identityInfo.expiryDate',
            value:null,
        })
    
    }

    if( cardTypesForPassport.some(element=> cardTypeList.includes(element)))
   {
        store.commit('updateField', {
            key: 'identityInfo.passport.number',
            value: null,
        })
        store.commit('updateField', {
            key: 'identityInfo.passport.expiryDate',
            value: null,
        })
        // store.commit('updateField', {
        //     key: 'identityInfo.isLifetimeExpiry',
        //     value: null,
        // })
    }
  
    if( cardTypesForFatherName.some(element=> cardTypeList.includes(element))){
        store.commit('updateField', {
            key: 'basicInfo.fatherName',
            value: null,
        })
    }
   
  }

async function isUpdateField(fieldKey){
    let fieldValue = store.getters.getField(fieldKey);
    let selectedCardType = store.getters.getField('identityInfo.cardType');
    let countries = ['UAE','Qatar']
    let cardTypes = [ 'QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK',
                      'ARE ID 0 FRONT', 'ARE ID 0 BACK', 
                      'ARE ID 1 FRONT', 'ARE ID 1 BACK'
                    ]

    if( (countries.includes(tempCountry) && cardTypes.some(element=> cardTypeList.includes(element)) ) || !fieldValue || !selectedCardType ){
      return true
    }else if ( !countries.includes(tempCountry) ){
       return true
    }
    return false
 }
